import React from 'react';
import AboutHeader from './AboutHeader'
import SecOneAboutMe from './SecOneAboutMe'
// import SecTwoAboutMe from './SecTwoAboutMe'

const AboutMe = () => {
    return (
        <div >
            <AboutHeader/>
            <SecOneAboutMe/>
            <div>
                <img id="aboutMe-pic3" alt="" src=""/>
            </div>
        </div>
    );
};

export default AboutMe;